"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _getValue = _interopRequireDefault(require("../getValue"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/Loader/index.js";
function Loader(_ref) {
  var className = _ref.className,
    children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '' : _ref$size,
    _ref$transaparent = _ref.transaparent,
    transaparent = _ref$transaparent === void 0 ? false : _ref$transaparent;
  var classes = (0, _classNames["default"])(className, 'd-flex justify-content-center align-items-center');
  var classLoader = (0, _classNames["default"])('loader rotate me-2', className, size, (0, _getValue["default"])(transaparent, 'transparent'));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classLoader,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 13
    }
  }), children ? children : null);
}
var _default = exports["default"] = Loader;